import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const SrSecondarySchool = () => {
     useEffect(() => {
        document.title = 'SrSecondary School -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>SrSecondary School </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Sr Secondary School  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <h3> Sr Secondary Stage (Class XI - XII) </h3>
       <p>The Senior Secondary Stage deepens academic specialization while preparing students for the Class XII Board Examination and post-school pathways. Students select streamwise subjects (e.g., Science, Commerce, Humanities) and work at greater depth through practicals, research tasks, seminars, and projects. Emphasis is on independent learning, analytical reasoning, academic writing, and ethical conduct—supported by counseling for careers, college applications, and competitive exams where relevant.</p>
       <p><b>Key Areas of Focus:</b></p>
       <ul className="list">
       <li> <b> Stream mastery: </b> Rigorous coverage of core and elective subjects with conceptual depth and real-world application.
       </li>
       <li> <b> Board-exam readiness: </b> Syllabus mapping, practice papers, internal assessments/practicals, exam strategies.
       </li>
       <li> <b> Inquiry & Research: </b> Investigatory projects, lab work/fieldwork, data analysis, citations and academic honesty.
       </li>
       <li> <b> Quantitative & digital literacy: </b> Data handling, spreadsheets/tools, responsible digital citizenship.
       </li>
       <li> <b>Career & college guidance: </b> Aptitude building, portfolio/SOP prep, awareness of entrance exams and options.
       </li>
       <li> <b> Leadership & life skills: </b> Time/project management, teamwork, house activities, clubs, community service.
       </li>
       <li> <b> Wellbeing & values: </b> Discipline, resilience, empathy, and civic responsibility.</li>
       </ul>
       <p><b>Learning Outcomes:</b></p> 
       <ul className="list">
       <li> Demonstrate advanced understanding in chosen subjects and apply concepts to unfamiliar, multi-step problems
       </li>
       <li>Design and execute research/practical work; interpret data to draw evidence-based conclusions
       </li>
       <li> Manage goals, timelines, and exam preparation with autonomy and resilience
       </li>
       <li> Make informed choices about higher education and careers; approach the Class XII Board with confidence and strategy</li>
       </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default SrSecondarySchool
